import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { getUser } from '../../../../user';

const AccessButton = ({ className, record }) => {
  const user = getUser();
  return (
    <Fragment>
      <Route
        render={() => {
          return (
            <MenuItem
              className={className}
              variant="contained"
              onClick={() => {
                window.open(
                  'https://quality-control.bubbleapps.io/access?account_id=' +
                    `${record.id}` +
                    '&manager_email=' +
                    `${record.manager_email}` +
                    '&manager_id=' +
                    `${user.id}`,
                );
              }}
            >
              <ListItemText primary="🔑 Récupération des accès" />
            </MenuItem>
          );
        }}
      />
    </Fragment>
  );
};

AccessButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
};

AccessButton.defaultProps = {
  className: undefined,
  record: undefined,
};

export default AccessButton;
